import * as React from "react";
import { Fragment } from "react";
import ReactDOM from "react-dom";
import { getCookie } from "typescript-cookie";

const ModalOverlay: React.FC<{ onClose: () => void }> = (props) => {
  let productCount: number;
  let inflectedMessage: string = "V porovnávači nyní máte ";
  let showButton: boolean = true;

  let cookies = getCookie("products_ids_to_compare")?.split("&");
  cookies = cookies?.filter((e) => e);
  if (cookies) {
    productCount = cookies.length;
    switch (productCount) {
      case 0:
        inflectedMessage = "Všechny produkty byly z porovnávače vymazány.";
        showButton = false;
        break;
      case 1:
        inflectedMessage += "1 produkt.";
        showButton = true;
        break;
      case 2:
      case 3:
      case 4:
        inflectedMessage += productCount + " produkty.";
        showButton = true;
        break;
      default:
        inflectedMessage += productCount + " produktů.";
        showButton = true;
        break;
    }
  } else {
    inflectedMessage = "Všechny produkty byly z porovnávače vymazány.";
    showButton = false;
  }

  return (
    <div className={"modal-overlay"}>
      <div className="comparator-message">
        <div className="centered">
          <p>{inflectedMessage}</p>
          {showButton && (
            <a href="/porovnavac/" className="button button-primary">
              Přejít do porovnávače
            </a>
          )}
          <button className={"close"} onClick={props.onClose}>
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

const portalElement = document.getElementsByTagName("body")[0];

const ComparatorModal: React.FC<{ onClose: () => void }> = (props) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <ModalOverlay onClose={props.onClose} />,
        portalElement
      )}
    </Fragment>
  );
};

export default ComparatorModal;
